var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7046 12.7655C16.6766 9.58692 19.2474 8.04053 19.365 7.96853C17.909 5.79589 15.6524 5.49904 14.8593 5.47537C12.964 5.27122 11.1255 6.63615 10.16 6.63615C9.17523 6.63615 7.68844 5.4951 6.08601 5.52863C4.02397 5.56117 2.0949 6.7831 1.0369 8.68059C-1.14656 12.5495 0.481879 18.2351 2.57379 21.3624C3.62023 22.894 4.84301 24.6041 6.4435 24.5439C8.00931 24.4778 8.59419 23.5222 10.4838 23.5222C12.356 23.5222 12.9052 24.5439 14.5375 24.5055C16.218 24.4778 17.276 22.967 18.2858 21.4216C19.4951 19.6661 19.9807 17.9372 20 17.8485C19.9605 17.8347 16.7364 16.5753 16.7046 12.7655Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0434 3.78592C14.9682 2.77394 15.6009 1.39715 15.4252 0C14.0868 0.0518493 12.413 0.810145 11.4491 1.79991C10.5963 2.67209 9.83452 4.10165 10.0313 5.44603C11.5348 5.54417 13.0785 4.78217 14.0434 3.78592Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.380f1854288101bf1dcff7bd61737073.svg";
export { ForwardRef as ReactComponent };